import { generatePath } from 'react-router-dom';
import { ApiRoutes } from 'types';
import { CampaignBatchStatsResponse, ReportingUrlsResponse, StatsResponse } from 'types/Stats';
import { getApiUrl } from './helpers';
import { axiosSecretAuthInstance } from './axiosInstance';

export async function checkStats(campaignId: number) {
  const path = generatePath(ApiRoutes.Stats);
  const { data } = await axiosSecretAuthInstance().get<StatsResponse>(getApiUrl({ path }), { params: { campaignId } });
  return data;
}

export async function fetchCampaignListStats() {
  const path = generatePath(ApiRoutes.CampaignStats);
  const { data } = await axiosSecretAuthInstance().get<CampaignBatchStatsResponse>(getApiUrl({ path }));
  return data;
}

export async function getReportingUrls(campaignId: number) {
  const path = generatePath(ApiRoutes.ReportingUrls);
  const { data } = await axiosSecretAuthInstance().get<ReportingUrlsResponse>(getApiUrl({ path }), {
    params: { campaignId },
  });
  return data;
}
